"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeGetProductGroupState = void 0;
const reselect_1 = require("reselect");
const getProductGroup = (state) => state.productGroup;
const makeGetProductGroupState = () => (0, reselect_1.createSelector)(getProductGroup, (products) => products);
exports.makeGetProductGroupState = makeGetProductGroupState;
